<template>
  <div @keydown.enter="authenticate" class="Login">
    <el-row type="flex" align="middle" justify="center">
      <el-col :span="6">
        <el-card class="box-card">
          <div class="logo-container">           
          </div>
          <div slot="header" class="clearfix header-row">
            <span class="title">BHS CMMS</span>
            <div class="subtitle-row">
              <img src="logo_las.png" alt="Logo" class="logo-img-small" />
              <span class="subtitle">LAS Solutions</span>
            </div>
            <div><i>version: {{ $store.getters.getVersion }}</i></div>
          </div>
          <div class="input-container">
            <label for="username">Username</label>
            <el-input id="username" placeholder="Enter your username" v-model="username"></el-input>
          </div>
          <div class="input-container">
            <label for="password">Password</label>
            <el-input id="password" type="password" placeholder="Enter your password" v-model="password"></el-input>
          </div>
          <div class="button-container">
            <el-button type="primary" @click.native="authenticate">Login</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts">
import { login } from "../api/login";
import { Component, Vue, Prop } from "vue-property-decorator";
import { postgrest } from '../api/postgrest';

@Component({})
export default class Login extends Vue {
  public userList: string[] = [];
  public username: string = "";
  public password: string = "";

  public async authenticate(): Promise<void> {
    if (!this.$store.state.loggedIn) {
      try {
        const loginchunk = await login.getUser(
          this.username,
          this.password,
          this.$store.getters.getHost,
          this.$store.getters.getConnectionDuration
        );
        let resp = await loginchunk.json();
        this.$store.dispatch("AddUserName", resp.username);
        this.$store.dispatch("AddToken", resp.token);
        this.$store.dispatch("login");
        this.$store.dispatch("updateUserLevel", resp.level);
        this.$store.dispatch("updateCurrentComponent", "Welcome");
        this.$store.dispatch("setCurrentId", -1);
        this.$store.dispatch("resetTime");
        // kanei riset sti mia wra
        this.$router.replace({ name: "load" });

        try {
          console.log('Postgrest call')
          console.log('token --->',this.$store.getters.getToken);
          let res = await postgrest.get('companies', this.$store.getters.getToken);
          console.log('Postgrest result:' + JSON.stringify(res));
        } catch (ex) {
          console.log('Postgrest call exception:' + ex);
        }

        console.log("Userlevel:" + this.$store.state.userlevel);
      } catch (ex) {
        console.log("Failed logging in");
        return Promise.resolve();
      }
    } else {
      console.log("already logged");
    }
  }

  public async mounted() {
    await this.$store.dispatch("updateConnectionSettings");
    console.log("Login mounted()");
  }
}
</script>

<style scoped>


.box-card {
  border-radius: 22px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);
  background: #f4faff;
  padding: 38px 28px 28px 28px;
  margin-top: 40px;
  border: none;
  position: relative;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 14px;
}

.logo-img {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: #e3f0ff;
  box-shadow: 0 2px 8px rgba(64,158,255,0.10);
  object-fit: cover;
  border: 3px solid #b3d8fd;
}

.title {
  line-height: 36px;
  color: #409EFF;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}

.header-row {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.subtitle-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  margin-top: -4px;
}

.logo-img-small {
  width: 40px;
  height: 40px;
  border-radius: 20%;
  background: #e3f0ff;
  box-shadow: 0 2px 8px rgba(64,158,255,0.10);
  
  margin-right: 10px;
}

.subtitle {
  font-size: 1.1rem;
  color: #409EFF;
  letter-spacing: 1px;
  font-style: italic;
}

.input-container {
  margin-bottom: 24px;
}

.input-container label {
  display: block;
  margin-bottom: 6px;
  color: #606266;
  font-weight: 500;
}

.el-input__inner {
  border-color: #c0c4cc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1rem;
  background: #fafdff;
}

.el-button--primary {
  background-color: #67C23A;
  border-radius: 8px;
  font-size: 1.1rem;
  padding: 10px 32px;
  transition: background 0.2s;
}

.el-button--primary:hover {
  background-color: #5CAD32;
}

.button-container {
  text-align: center;
  margin-top: 18px;
}

.clearfix {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.clearfix i {
  font-size: 0.95rem;
  color: #888;
  margin-top: 4px;
}

/* .Login {

  


} */
</style>
